'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = format;

var _accounting = require('accounting');

var _accounting2 = _interopRequireDefault(_accounting);

var _currencySymbolMap = require('currency-symbol-map');

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

var _lodash = require('lodash');

var _extend = require('extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatForStore(code) {
  var config = {
    default: {
      decimal: '.',
      format: '%s%v'
    },
    efrdxv: {
      decimal: ',',
      format: '%v %s'
    },
    enlflx: {
      decimal: ',',
      format: '%s%v'
    },
    ebelev: {
      decimal: ',',
      format: '%s%v'
    },
    eesbru: {
      decimal: ',',
      format: '%v %s'
    }
  };

  if ((0, _lodash.has)(config, code)) {
    return config[code];
  }

  return config.default;
}

function currencySymbol(currency) {
  return (0, _currencySymbolMap2.default)(currency);
}

function format(amount, currency, store) {
  return _accounting2.default.formatMoney(amount, (0, _extend2.default)(true, {
    symbol: currencySymbol(currency),
    precision: 2
  }, formatForStore(store.code)));
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/money.js
// module id = 96
// module chunks = 0